import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import { post } from 'axios';


// Initializing Firebase
const config = {
  apiKey: "AIzaSyA5n_Hv9livSdbKGLuGJ_xga-K3z4iSf9A",
  authDomain: "jeel-df8a7.firebaseapp.com",
  databaseURL: "https://jeel-df8a7.firebaseio.com",
  projectId: "jeel-df8a7",
  storageBucket: "jeel-df8a7.appspot.com",
  messagingSenderId: "846403722503",
  appId: "1:846403722503:web:a6367f1c48b21dbfdb39a2",
  measurementId: "G-QCMM45E39K"
};

// var secondaryApp = firebase.initializeApp(config, "Secondary");

class FirebaseConfig {
  constructor() {
    this.auth = firebase.auth();

  }

  doSignInWithEmailAndPassword = (email, password) =>
    this.auth.signInWithEmailAndPassword(email, password);

  doSignOut = () => this.auth.signOut();

  doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

  doPasswordUpdate = password =>
    this.auth.currentUser.updatePassword(password);
}
// firebase.initializeApp(config);
// firebase.firestore().settings({ timestampsInSnapshots: true });

export default FirebaseConfig;
